/*
 * Copyright (c) 2023. RoZetta Technology Pty Ltd. All rights reserved.
 */

import {
	Grid,
	Stack,
	TextField,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Typography,
	Alert
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import {requestAccessIntro, requestAccessIntro2} from "../assets/texts/pageTextContent";
import {EmailEndpoint} from "../config/backendConfig";
import {newRequestForm, type RequestForm} from "../components/scenario-modelling/TableData";
import isEmail from "validator/lib/isEmail";

const Item = styled(Paper)(({ theme }) => ({
	backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
	...theme.typography.body2,
	padding: theme.spacing(1),
	textAlign: "center",
}));

const jurisdiction = [
	{
		value: "IA",
		label: "IA",
	},
	{
		value: "FED",
		label: "FED",
	},
	{
		value: "NSW",
		label: "NSW",
	},
	{
		value: "VIC",
		label: "VIC",
	},
	{
		value: "ACT",
		label: "ACT",
	},
	{
		value: "NT",
		label: "NT",
	},
	{
		value: "WA",
		label: "WA",
	},
	{
		value: "QLD",
		label: "QLD",
	},
	{
		value: "TAS",
		label: "TAS",
	},
	{
		value: "SA",
		label: "SA",
	},
];

export default function RequestAccess () {
	const [open, setOpen] = React.useState(false);
	const [errorMessage, seterrorMessage] = React.useState("");
	const [requestForm, setRequestForm] = React.useState<RequestForm>(newRequestForm);
	const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		if (isEmail(requestForm.email)) {
			await fetch(EmailEndpoint, {
				method: "POST",
				body: JSON.stringify(requestForm)
			});
			setOpen(true);
			setRequestForm(newRequestForm);
		} else {
			seterrorMessage("Invalid email address");
		}

	};

	const handleClose = () => {
		setOpen(false);
	};
	const history = useNavigate();
	return <Grid container spacing={5} sx={{ height:"80%", pt: "5%" }} justifyContent='center'>
		<Grid item xs={4} >
			<Typography
				variant={"h2"}
				component="div"
			>
				{requestAccessIntro}
				<br/>
				<br/>
				{requestAccessIntro2}
			</Typography>
		</Grid>
		<Grid item xs={3}>
			{ errorMessage && <Alert severity="error">{errorMessage}</Alert> }
			<form onSubmit={handleSubmit}>
				<Stack spacing={2} >
					<TextField
				    required
						id="access-name"
						label="Name"
						variant="outlined"
						onChange={(e) => {
							setRequestForm({...requestForm, ["name"]: e.target.value});
						}
						}
						value={requestForm.name}
					/>
					<TextField
				    required
						id="access-email"
						label="Email"
						variant="outlined"
						error={requestForm.email != "" && !isEmail(requestForm.email)}
						onChange={(e) => {
							seterrorMessage("");
							setRequestForm({...requestForm, ["email"]: e.target.value});
						}
						}
						value={requestForm.email}
					/>
					<TextField
						id="access-job"
						label="Job Title"
						variant="outlined"
						onChange={(e) => {
							setRequestForm({...requestForm, ["title"]: e.target.value});
						}
						}
						value={requestForm.title}
					/>
					<TextField
				    required
						id="access-org"
						label="Organisation"
						variant="outlined"
						onChange={(e) => {
							setRequestForm({...requestForm, ["org"]: e.target.value});
						}
						}
						value={requestForm.org}
					/>
					<TextField
				    required
						id="access-jur"
						select
						label='Jurisdiction'
						variant="outlined"
						onChange={(e) => {
							setRequestForm({...requestForm, ["juri"]: e.target.value});
						}
						}
						value={requestForm.juri}
					>
						{jurisdiction.map((option) => (
							<MenuItem key={option.value} value={option.value}>
								{option.label}
							</MenuItem>
						))}
					</TextField>
					<Item>
						<Grid
							container
							spacing={1}>
							<Grid item xs={6} >
								<Button variant='contained' type="submit">Submit</Button>
								<Dialog open={open} onClose={handleClose}>
									<DialogTitle>Access Request</DialogTitle>
									<DialogContent>
										<DialogContentText>
                                        Thank you for requesting access to the Infrastructure Australia Scenario Modelling Tool. An acknowledgment email has been sent to your inbox.
											<br/>
											<br/>
                                        Your request will be reviewed by a team member and you will be notified of the outcome.
										</DialogContentText>
									</DialogContent>
									<DialogActions>
										<Button onClick={handleClose}>Cancel</Button>
									</DialogActions>
								</Dialog>
							</Grid>
							<Grid item xs={6}>
								<Button
									onClick={() => history(-1)}
									variant='contained'
								>
                                cancel
								</Button>
							</Grid>
						</Grid>
					</Item>
				</Stack>
			</form>
		</Grid>
	</Grid>;
}
